<template lang="html">
    <ZDialog v-bind:active.sync="show">
        <template slot="title">
            <div v-html="title"></div>
        </template>
        <template slot="default">
            <div v-if="message" v-html="message"></div>
        </template>
        <template slot="actions">
            <ZButton @click="cancel"  accent>Отмена</ZButton>
            <ZButton @click="confirm" primary>Ок</ZButton>
        </template>
    </ZDialog>
</template>
<script>
    import ZDialog from './ZDialog.vue'
    import ZButton from './ZButton.vue'
    export default {
        name: 'z-modal-alert',
        components: {ZDialog, ZButton},
        props: {},
        data() {
            return {
                show: false,
                title: null,
                message: null,
                confirmCallback: null,
                cancelCallback: null
            }
        },
        created() {
            this.listeners();
        },
        watch: {},
        computed: {},
        methods: {
            listeners() {
                this.$root.$on('z-alert', (title, message = null, confirmCallback = null, cancelCallback = null) => {
                    if (!title) return;
                    this.message         = (message)         ? message         : null;
                    this.confirmCallback = (confirmCallback) ? confirmCallback : null;
                    this.cancelCallback  = (cancelCallback)  ? cancelCallback  : null;
                    this.title = title;
                    this.show  = true;
                });
            },
            confirm() {
                if (this.confirmCallback) this.confirmCallback();
                this.close();
            },
            cancel() {
                if (this.cancelCallback) this.cancelCallback();
                this.close();
            },
            close() {
                this.show = false;
            }
        }
    }
</script>
<style lang="sass">
</style>


// WEBPACK FOOTER //
// ZModalAlert.vue?95085bb0